import { useMemo } from 'react';
import { kioskStore } from '~/stores/kiosk.store';
import { ENV_FIT_MODE, FitMode } from '~/utils/viewportFit';

/**
 * Hook que resolve o modo de renderização efetivo considerando overrides
 * automáticos.
 *
 * Atualmente:
 * - Android + kiosk OFF → força `'contain'` (preserva status/nav bars do
 *   Android pra operador acessar Settings, Wi-Fi, Factory Reset).
 * - Outros casos → `ENV_FIT_MODE` (build-time flag).
 *
 * **NÃO é observer.** Quem usa este hook precisa ser `observer` do mobx
 * pra reagir a mudanças em `kioskStore.isLocked`.
 *
 * Futuro (Fase 3 do roadmap): consultar `playerSettingsStore.fitMode`
 * antes do ENV_FIT_MODE pra suporte a configuração por tenant.
 */
export const useEffectiveFitMode = (): FitMode => {
  // useMemo só pra clareza — kioskStore.isLocked é observable então o
  // componente caller re-renderiza quando muda; useMemo aqui é no-op
  // de performance mas comunica intenção.
  const isAndroid = import.meta.env.VITE_PLATFORM === 'android';
  const isKioskLocked = kioskStore.isLocked;

  return useMemo<FitMode>(() => {
    if (isAndroid && !isKioskLocked) {
      return 'contain';
    }
    return ENV_FIT_MODE;
  }, [isAndroid, isKioskLocked]);
};
